import { jsx as u, jsxs as ne, Fragment as ce } from "react/jsx-runtime";
import { forwardRef as Ps, useState as E, useRef as Ms, useImperativeHandle as xs, useEffect as z, useMemo as $s } from "react";
import { useTranslation as Bs, useToast as Us, useSession as Gs, Notification as Dt, Theme as Pe, InputValidations as Ae, Checkbox as Et, ButtonTypes as Hs, ButtonStyles as Ys, ButtonSize as Ks, Button as js, Input as qs, DropDown as Ws } from "@nextgen-web-framework/all";
import { A as Xs } from "./Logger-51340717.mjs";
import { Q as At } from "./profileApi-36f0a1f0.mjs";
import { o as oe } from "./ContactType-9a05b343.mjs";
import { o as Js, a as Qs } from "./Utils-afbe19af.mjs";
import { C as Ce } from "./profileInformationEnums-e12b5b99.mjs";
import { useFormik as Zs } from "formik";
import en from "./components/Common/ButtonWithLoading/ButtonWithLoading.js";
import tn from "./components/Common/PhoneNumberInput/PhoneNumberInput.js";
import { DisplayField as Ct } from "./components/Common/DisplayField/DisplayField.js";
import { MyAccountExtEnum as f, MyAccountFieldType as ue, ToastMessageEnum as Vt } from "./utils/types/enum.js";
import { useLocale as sn } from "./utils/customHooks.js";
import { useCountryMasterData as nn, useMyAccountAddressConfig as on } from "./utils/masterdata.js";
import { h as an, a as m, p as rn, e as dn, A as ln, B as cn, C as un, D as pn, k as _t, E as hn, F as Ft, c as fn, G as gn, H as In, I as mn } from "./myAccountProfileUtils-4d931e10.mjs";
import { o as D } from "./Constants-8ae3f1bb.mjs";
import Sn from "./components/Common/InputErrorComponent/InputErrorComponent.js";
import { inputErrorStatus as bt, inputErrorMessage as Tt } from "./components/Common/InputErrorComponent/utils.js";
import Dn from "./components/Common/SearchDrawer/SearchDrawer.js";
import En from "./components/AddressLookup/AddressLookup.js";
import { o as yt, p as g, h as Me, a as ae, u as Lt, q as xe, j as An } from "./helper-3061fae6.mjs";
import { useGlobalErrorHandler as Cn } from "./utils/globalErrorHook.js";
import { l as Vn } from "./logObject-9202373b.mjs";
import { p as _n } from "./parsePhoneNumberWithError-36fb3222.mjs";
import { i as Fn } from "./isValidPhoneNumber-e7deec18.mjs";
import './assets/AddressInput.css';const bn = {
  Validated: "VALIDATED",
  NotValidated: "NOT_VALIDATED"
}, Tn = "#ffffff", yn = "#396e75", Ln = "#e5fdff", wn = "#546223", On = "#f0fae5", kn = "#a65523", vn = "#fff1e8", Rn = "#7f3e3e", Nn = "#ffe2e2", zn = "#62625a", Pn = "#f8f8e7", Mn = "#38539a", xn = "#707070", $n = "#c8f8d1", Bn = "#87c9c8", Un = "#5291b1", Gn = "rgba(82, 145, 177, 0.1019607843)", Hn = "#445685", Yn = "#181d61", Kn = "rgba(24, 29, 97, 0.1019607843)", jn = "#5969d6", qn = "#ea999d", Wn = "#b6577e", Xn = "rgba(182, 87, 126, 0.1019607843)", Jn = "#7e3e80", Qn = "#1e247f", Zn = "rgba(30, 36, 127, 0.1019607843)", eo = "#da7600", to = "#107f47", so = "#d91734", no = "_html_uzw3t_75", oo = "_mobile_uzw3t_304", ao = "_desktop_uzw3t_318", w = {
  amwayWhite: Tn,
  darkBlue: yn,
  lightBlue: Ln,
  darkGreen: wn,
  lightGreen: On,
  darkOrange: kn,
  lightOrange: vn,
  darkRed: Rn,
  lightRed: Nn,
  darkYellow: zn,
  lightYellow: Pn,
  darkPurple: Mn,
  darkGrayOnWhite: xn,
  dataVizColor1: $n,
  dataVizColor2: Bn,
  dataVizColor3: Un,
  dataVizColor3Background: Gn,
  dataVizColor4: Hn,
  dataVizColor5: Yn,
  dataVizColor5Background: Kn,
  dataVizColor6: jn,
  dataVizColor7: qn,
  dataVizColor8: Wn,
  dataVizColor8Background: Xn,
  dataVizColor9: Jn,
  dataVizColor10: Qn,
  dataVizColor10Background: Zn,
  dataVizAlertOrange: eo,
  dataVizSuccessGreen: to,
  dataVizWarningRed: so,
  "no-visible": "_no-visible_uzw3t_34",
  html: no,
  "address-input-container": "_address-input-container_uzw3t_142",
  "address-input-drawer": "_address-input-drawer_uzw3t_143",
  "address-custom-header": "_address-custom-header_uzw3t_163",
  "address-type-title": "_address-type-title_uzw3t_190",
  "address-form": "_address-form_uzw3t_211",
  "general-address-container": "_general-address-container_uzw3t_232",
  "grouped-fields": "_grouped-fields_uzw3t_268",
  mobile: oo,
  desktop: ao,
  "available-width": "_available-width_uzw3t_345",
  "character-count": "_character-count_uzw3t_357",
  "guided-input": "_guided-input_uzw3t_365",
  "shipping-detail-container": "_shipping-detail-container_uzw3t_369",
  "shipping-address-form-btn": "_shipping-address-form-btn_uzw3t_425",
  "hidden-button": "_hidden-button_uzw3t_452"
}, ro = Ps(
  ({
    contactType: A = oe.Shipping,
    accountNumber: wt,
    ownerId: Ve = "",
    // for shipping address only, this is profileId
    address: p,
    ownerType: $e = Js.Profile,
    // Default for shipping address
    className: Ot,
    callback: re,
    validationCB: Be,
    externalUse: ie,
    allowEnterManually: kt = !0,
    // isMandatory = false,
    useMobileView: Ue = !0,
    header: Ge,
    useDesktopView: _e,
    disabled: Y,
    disableDeliveryInstructions: vt = !1,
    showShippingParticulars: Rt = !0,
    // From existing shipping form
    title: He,
    isEdit: Ye,
    showDefaultAddressCheckbox: Nt,
    hideConfirmButton: de,
    isLoading: Ke = !1,
    lookupEnabled: zt,
    // For validation purpose
    validateOnMount: Pt,
    updateCallbackOnMount: Fe = !0,
    message: pe,
    status: be,
    updateDisableButton: Te,
    useAvailableWidth: je
  }, Mt) => {
    var It, mt, St;
    const qe = Xs.getInstance(Vn("AddressInput.tsx", "AddressInput")), C = Bs(), { addToast: We } = Us(), { session: xt } = Gs(), { aboNum: $t } = xt, Bt = C(`profile.AddressInput.${A.toLowerCase()}Address`), Ut = C("profile.AddressInput.save.success"), Gt = C("profile.AddressInput.save.failed"), ye = Cn(), Xe = sn(), [B] = String(Xe).split("-"), { currentCountry: K } = nn(), Ht = `(+${K == null ? void 0 : K.phoneCode})`, Je = (It = K == null ? void 0 : K.pk) == null ? void 0 : It.toUpperCase(), j = Qs(A, wt ?? $t, $e, Ve), [he, q] = E(!1), [fe, Yt] = E(!1), [Kt, Qe] = E(!1), [Ze, et] = E(j), [tt, jt] = E(!1), [U, Le] = E(""), [W, st] = E(""), [qt, nt] = E(""), [X, we] = E(!1), [Wt, ot] = E(!1), [Xt, ge] = E(!1), [Jt, at] = E(""), [Qt, rt] = E({
      fieldName: "",
      dispLabel: "",
      data: [],
      selectedItem: ""
    }), [le, Zt] = E([]), [J, es] = E([]), [Ie, it] = E([]), [N, ts] = E(), [ss, ns] = E(!1), [os, dt] = E(!1), lt = Ms(null), as = on(), { inputs: S, ext: me } = an(as, A), Q = zt ?? m(f.USE_ADDRESS_LOOKUP, me), Oe = m(f.GUIDED_INPUT, me), rs = m(f.GUIDED_INPUT_SKIP_OPTIONAL_FIELD, me), ct = m(f.SHOW_DEFAULT_ADDRESS, me) && !ie || Nt, ut = Oe && (J == null ? void 0 : J.length) > 0, Z = Pt ?? !!(p != null && p.contactId), is = [
      D.DELIVERY_INSTRUCTIONS,
      D.ADDRESS_LINE_ONE,
      D.ADDRESS_LINE_TWO,
      D.ADDRESS_LINE_THREE,
      D.CONTACT_NICKNAME,
      D.RECIPIENT_FIRST_NAME,
      D.RECIPIENT_LAST_NAME,
      // LATAM
      D.ADDRESS_TYPE_OTHER,
      D.MAIN_ROAD,
      D.SIDE_LINE,
      D.NUMBER
    ], ke = rn(S), ds = dn(S), pt = Ue && !_e ? w.mobile : "";
    let ve = yt(!!_e, w.desktop, "");
    je && (ve = w["available-width"]);
    const o = Zs({
      initialValues: j,
      validationSchema: ke,
      validateOnMount: Z,
      validateOnBlur: !0,
      validateOnChange: !0,
      onSubmit: (e) => Ss(e)
    });
    xs(Mt, () => ({
      validate: () => {
        const e = {};
        S == null || S.filter((t) => t.visible).forEach((t) => {
          const { fieldName: s } = t;
          e[s] = !0;
        }), o.setTouched(e, !0);
      },
      resetErrors: () => {
        o.setErrors({}), o.setTouched({}), o.resetForm({});
      },
      getAddress: Re
    })), z(() => {
      Oe && (us(), ps());
    }, [Oe]), z(() => {
      le && hs();
    }, [le, Xe]), z(() => {
      q(!Q);
    }, [Q]), z(() => {
      !he && fe && o.setValues(p ?? j, Z);
    }, [he, fe]), z(() => {
      if (p != null && p.addrLineOne || p != null && p.contactId) {
        const e = gs(p);
        o.setValues(e, Z), q(!0);
        const t = (p == null ? void 0 : p.phone) && _n(p.phone);
        t && (Le(`(+${t.countryCallingCode})`), st(t.nationalNumber));
      } else
        Q && !tt && (o.setValues(j), q(!1));
      ns(!!(p != null && p.isDefault)), setTimeout(() => {
        Yt(!0);
      }, 0);
    }, [p == null ? void 0 : p.addrLineOne]), z(() => {
      var e;
      ((e = o.values) == null ? void 0 : e.addrLineOne) === "" && fe && Q && !tt && (o.setValues(j), q(!1));
    }, [(mt = o.values) == null ? void 0 : mt.addrLineOne, fe]), z(() => {
      if ((A !== oe.Shipping || ie) && Object.keys(o.touched).length > 0 && re) {
        const t = Re();
        re == null || re(t);
      }
    }, [o.values, o.touched, Ze, Kt, X]);
    const Re = (e = o.values) => {
      const t = cs(e);
      return {
        ...p,
        ...t,
        // Remove matchId if address not same with selected address or modified
        matchId: yt(o.dirty, Ze.matchId, ""),
        addressValidationOverrideFlag: !1,
        feValidation: X,
        validationStatus: bn.Validated,
        contactType: A,
        countryCode: (e == null ? void 0 : e.countryCode) ?? Je,
        language: B,
        contactId: g(p == null ? void 0 : p.contactId)
      };
    };
    z(() => {
      const e = Ne(U, W), t = o.isValid && e && !!U;
      if (A === oe.Shipping) {
        const s = Fe || Object.keys(o.touched).length > 0;
        we(t && s);
      } else
        Cs();
    }, [o.values, o.touched, U, W, o.isValid, A, Fe]), z(() => {
      Te == null || Te(X);
    }, [X]);
    const ls = (e) => {
      var t;
      if (e.manualEntry)
        q(!0), et(j), jt(!0);
      else if ((t = e.address) != null && t.addrLineOne) {
        const { address: s } = e;
        o.setValues({
          ...o.values,
          addrLineOne: s == null ? void 0 : s.addrLineOne,
          addrLineTwo: s == null ? void 0 : s.addrLineTwo,
          addrLineThree: s == null ? void 0 : s.addrLineThree,
          state: s == null ? void 0 : s.state,
          city: s == null ? void 0 : s.city,
          postalCode: s == null ? void 0 : s.postalCode,
          countryCode: s == null ? void 0 : s.countryCode,
          matchId: s == null ? void 0 : s.matchId
        }), o.setTouched({ addrLineOne: !0 }), et(s), Qe(!0), q(!0);
      }
    }, ht = (e, t) => {
      We({
        id: Vt.SHIPPING_ADDRESS_VALIDATION_MESSAGE,
        timeout: 3e3,
        content: /* @__PURE__ */ u(Dt, { hasNotificationIcon: !0, theme: e, message: t })
      });
    }, Ne = (e, t) => e && t ? Fn(Me(e, t)) : !1, ft = (e) => S.find((t) => t.fieldName === e), cs = (e) => {
      const t = JSON.parse(JSON.stringify(e));
      Object.keys(t).forEach((n) => {
        const a = N == null ? void 0 : N.find((r) => r.secondaryField === n);
        if (a) {
          const { primaryField: r, copyData: d } = a;
          d && t[n] && (t[r] = t[n]);
        }
      });
      const s = S == null ? void 0 : S.find(
        (n) => {
          var a;
          return (a = n == null ? void 0 : n.ext) == null ? void 0 : a.some((r) => r.key === f.CONSTRUCT_FROM);
        }
      );
      return s && (t[s.fieldName] = ln(C, t, s, S)), t;
    }, us = async () => {
      ge(!0);
      const e = await ye(
        () => At.getAddressRegionData(Ce.STATE, B == null ? void 0 : B.toLowerCase())
      );
      Zt(e), ge(!1);
    }, ps = () => {
      const e = S.filter(
        (s) => s.fieldType === ue.GUIDED_INPUT && (s == null ? void 0 : s.options) && (s == null ? void 0 : s.options.length) > 0
      ), t = [...Ie];
      e == null || e.forEach(({ fieldName: s, options: n }) => {
        const a = n == null ? void 0 : n.map((r) => ({
          ...r,
          // Key = label key
          // Value = data value
          name: C(`profile.AddressInput.${s}.${r == null ? void 0 : r.key}`)
          // display
        }));
        t.push({
          fieldName: s,
          searchKeyword: "",
          data: a
        });
      }), it(t);
    }, hs = () => {
      let e = [];
      e = le == null ? void 0 : le.map((t) => {
        var n;
        const s = C(`profile.AddressInput.state.${Je}.${(n = t == null ? void 0 : t.state) == null ? void 0 : n.replaceAll(" ", "_")}`);
        return {
          value: g(t == null ? void 0 : t.state),
          name: g(s)
        };
      }), es(e);
    }, fs = async (e, t, s) => {
      let n = [];
      if (e === D.STATE)
        n = J;
      else if (s && Array.isArray(s)) {
        const a = Se(e), { data: r } = a || {};
        n = ae(r);
      } else {
        let a = "", r = "";
        const { state: d, district: l, city: c, subDistrict: i } = o.values;
        let h = l;
        ft(D.DISTRICT) || (h = c);
        let V = i;
        switch (ft(D.SUB_DISTRICT) || (V = "-"), t || e) {
          case D.DISTRICT:
            a = Ce.DISTRICT, r = g(d);
            break;
          case D.SUB_DISTRICT:
            a = Ce.SUBDISTRICT, r = `${g(d)}/${g(h)}`;
            break;
          case D.POSTAL_CODE:
            a = Ce.POSTALCODE, r = `${g(d)}/${g(h)}/${g(V)}`;
            break;
        }
        let _;
        const F = Se(e, r);
        if (F) {
          const { data: I } = F;
          _ = I;
        } else
          _ = await Is(a, d, h, V), mn(e, r, _, it);
        n = _ == null ? void 0 : _.map((I) => ({
          value: I,
          name: I
        }));
      }
      return {
        data: n
      };
    }, Se = (e, t = "") => Ie == null ? void 0 : Ie.find(
      (n) => n.fieldName === e && n.searchKeyword === t
    ), gs = (e) => {
      var n;
      let t = {
        ...e
      };
      const s = [];
      return (n = S == null ? void 0 : S.filter(
        (a) => {
          var r;
          return (r = a == null ? void 0 : a.ext) == null ? void 0 : r.some(
            (d) => [f.VISIBLE_IF, f.DISABLE_FIELD_ON_CHECK].includes(
              d.key
            )
          );
        }
      )) == null || n.forEach(({ fieldName: a, ext: r }) => {
        const d = m(f.VISIBLE_IF, r);
        if (d) {
          const { targetFieldName: c, targetFieldValue: i } = d, h = (e == null ? void 0 : e[c]) ?? null, V = S == null ? void 0 : S.find((F) => F.fieldName === c), b = ae(V == null ? void 0 : V.options), _ = b == null ? void 0 : b.find((F) => F.value === h);
          if (s.push({
            primaryField: c,
            secondaryField: a,
            copyData: !0
          }), (h === i || !_) && h !== null) {
            const F = Lt(h === i, "", h), I = h === i, L = Lt(h === "", "", i);
            t = {
              ...t,
              [c]: L,
              // set refField to default value
              ...I ? {} : { [a]: F }
              // Do not update the field if it's same value, let it as user's input
            };
          }
        }
        const l = m(f.DISABLE_FIELD_ON_CHECK, r);
        if (l) {
          const { targetFieldName: c } = l, i = (e == null ? void 0 : e[c]) ?? null;
          s.push({
            primaryField: c,
            secondaryField: a
          });
          const h = t.contactId ? !!i : !0;
          t = {
            ...t,
            [a]: !h
          };
        }
      }), ts(s), t;
    }, Is = async (e, t, s, n) => {
      try {
        const a = (d) => d.length === 1 ? d == null ? void 0 : d.replace("-", "") : d;
        ge(!0);
        const r = await ye(
          () => At.getAddressRegionSearch(e, {
            state: t,
            ...s && { district: a(s) },
            ...n && { subDistrict: a(n) },
            language: B == null ? void 0 : B.toLowerCase()
          })
        );
        return ge(!1), ae(r);
      } catch {
        return [];
      }
    }, ms = (e) => {
      ot(!1), rt({
        fieldName: "",
        config: {
          label: "",
          key: ""
        },
        data: [],
        selectedValue: ""
      }), at(""), e && De({
        target: {
          name: g(e)
        }
      });
    }, Ss = async (e) => {
      if (A === oe.Shipping && X && !ie && !os) {
        dt(!0);
        const t = Me(U, W), n = {
          ...Re(e),
          phone: t,
          ownerType: $e,
          ownerId: Ve
          // Send profile for shipping address (OwnerType=PROFILE)
        };
        if (Be) {
          const a = Be(n);
          if (a) {
            We({
              id: Vt.SHIPPING_ADDRESS_VALIDATION_FAILED,
              timeout: 3e3,
              content: /* @__PURE__ */ u(Dt, { hasNotificationIcon: !0, theme: Pe.ERROR, message: a })
            });
            return;
          }
        }
        await cn(
          {
            payload: n,
            originalAddress: p,
            ownerProfileId: Ve,
            isEdit: Ye,
            callback: re,
            successMessage: () => ht(Pe.SUCCESS, Ut),
            failedMessage: () => ht(Pe.ERROR, Gt)
          },
          ye
        ), dt(!1);
      }
    }, Ds = () => {
      const e = {};
      ds.forEach((t) => {
        e[t] = !0;
      }), o.setTouched(e);
    }, Es = async (e = !1, t) => {
      var s;
      if (A === oe.Shipping)
        try {
          if (await ke.validate(o.values), !Ne(U, W))
            throw new Error("InvalidPhone");
          return !0;
        } catch (n) {
          return e && (t == null || t.preventDefault(), t == null || t.stopPropagation(), n !== "InvalidPhone" && ((s = lt.current) == null || s.click())), !1;
        }
      return !1;
    }, As = (e, t, s, n, a) => {
      var i;
      const r = g(a, "profile.AddressInput.phone"), d = Ne(e, t);
      let l = "";
      return ((n == null ? void 0 : n.touched) || Z) && (s && (!e || !t) && (l = `${r}.required`), !l && e && t && !d && (l = `${r}.format`), !l && e && t && (n != null && n.error) && (l = (i = n == null ? void 0 : n.error) == null ? void 0 : i.replace("profile.validationMsg.phone", r))), l;
    }, Cs = async () => {
      try {
        await ke.validate(o.values), we(o.isValid && Object.keys(o.touched).length > 0), o.setErrors({});
      } catch {
        we(!1);
      }
    }, Vs = (e, t) => {
      var x, k, G, H;
      const { label: s, isEditableOnce: n, showCharCount: a, showAsInput: r, editable: d, required: l, max: c, min: i, excludeChars: h, ext: V } = t, b = { max: c, min: i }, _ = (T) => {
        De(T), a && nt("");
      }, F = e === D.DELIVERY_INSTRUCTIONS && vt, I = m(f.DISABLE_IF, V), { targetFieldName: L, targetFieldValue: P } = I || {}, M = (((x = o.values) == null ? void 0 : x[L]) ?? null) === P, O = m(f.REQUIRE_IF, V), te = ((k = o.values) == null ? void 0 : k[O == null ? void 0 : O.targetFieldName]) ?? null, Ee = O ? te === (O == null ? void 0 : O.targetFieldValue) : l, v = M ? "" : (G = o.values) == null ? void 0 : G[e], R = xe(C, s, Ee);
      if (d) {
        const T = o.getFieldMeta(e), y = Y || F || M, $ = !y && _t(Z, T.touched, n), se = T.error;
        return /* @__PURE__ */ ne(ce, { children: [
          /* @__PURE__ */ u(
            qs,
            {
              value: v,
              label: R,
              name: `${A}-${e}`,
              onChange: vs,
              onKeyUp: Rs,
              maxLength: c,
              disabled: y,
              onBlur: _,
              status: bt($, T.error),
              "data-testid": `address-input-${e}-testid`,
              message: Tt(C, $, se, b),
              onFocus: () => a ? nt(e) : null,
              autoComplete: "off"
            }
          ),
          qt === e && a && /* @__PURE__ */ ne("span", { className: w["character-count"], children: [
            An((H = hn(v, h)) == null ? void 0 : H.length),
            "/",
            c
          ] })
        ] });
      } else
        return /* @__PURE__ */ u(Ct, { fieldName: e, label: R, value: v, showAsInput: r });
    }, _s = (e, t) => {
      var d;
      const { label: s, editable: n } = t, a = (d = o.values) == null ? void 0 : d[e], r = (l) => {
        var i;
        o.setFieldValue(e, l.target.checked);
        const c = g(
          (i = N == null ? void 0 : N.find((h) => h.secondaryField === e)) == null ? void 0 : i.primaryField
        );
        c && l.target.checked && o.setFieldValue(c, "");
      };
      return n ? /* @__PURE__ */ u(
        Et,
        {
          name: `${A}-${e}`,
          id: `${A}-${e}`,
          text: s,
          checked: a,
          onChange: r,
          disabled: Y
        }
      ) : /* @__PURE__ */ u(Ct, { fieldName: e, label: s, value: a });
    }, Fs = (e, t, s, n) => {
      const { label: a, customLabel: r, editable: d, required: l, disabledCountry: c } = n;
      if (!d)
        return /* @__PURE__ */ u(ce, {});
      let i = C("profile.AddressInput.country");
      c && (i = "");
      const h = o.getFieldMeta(e), V = As(t, s, l, h, r), b = V ? Ae.INVALID : Ae.DEFAULT, _ = !!t && !!s, F = xe(C, C(a), l);
      return /* @__PURE__ */ u("div", { children: /* @__PURE__ */ u(
        tn,
        {
          name: e,
          dropdownLabel: i,
          inputLabel: F,
          configData: {
            label: "name",
            onSelect: (I) => {
              Le(I.name), o.setFieldValue(e, Me(I.name, s));
            }
          },
          onBlur: (I) => {
            var L;
            De(I), Ft(o, e, t, (L = I.target) == null ? void 0 : L.value, l);
          },
          onBlurCapture: De,
          inputValue: s,
          dropdownDisabled: c || Y,
          disabled: Y,
          onInputChange: (I) => {
            const L = g(I);
            st(L), Ft(o, e, t, L, l);
          },
          dropdownValue: t,
          disabledFilter: !0,
          autoComplete: "off",
          isAutoValidate: _,
          validationStatus: b,
          validationMessage: b && V && C(V)
        }
      ) });
    }, bs = (e) => {
      var s;
      const t = S.find((n) => n.fieldName === e);
      return (s = t == null ? void 0 : t.validations) != null && s.required || !rs ? e : g(m(f.DEPENDENCY, t == null ? void 0 : t.ext));
    }, Ts = async (e, t, s, n, a) => {
      at(t);
      const { data: r } = await fs(e, n, a);
      rt({
        fieldName: e,
        data: r,
        selectedValue: s,
        config: {
          label: "name",
          key: "value"
        }
      });
    }, ys = (e, t) => {
      var v, R, x, k, G, H;
      const { label: s, editable: n, required: a, isEditableOnce: r, ext: d, customLabel: l, options: c } = t, i = g(m(f.DEPENDENCY, d)), h = bs(i), V = ((v = o.values) == null ? void 0 : v[h]) ?? null, b = g(m(f.SEARCH_KEY, d)), _ = !!h && !V || Y || !ut, F = xe(C, s, a);
      let I = g((R = o.values) == null ? void 0 : R[e]);
      const L = g(l == null ? void 0 : l.split(".").pop()), P = (x = o.values) == null ? void 0 : x[e];
      if (e === D.STATE)
        I = g((k = J.find((T) => T.value === P)) == null ? void 0 : k.name);
      else if (c) {
        const T = m(f.OPTION_FALLBACK_VALUE, d), y = Se(e), { data: $ } = y || {}, se = (G = ae($).find((ze) => ze.value === P)) == null ? void 0 : G.name;
        I = g(se), T && !I && (p != null && p.contactId) && P && (I = (H = ae($).find((ze) => ze.value === T)) == null ? void 0 : H.name);
      }
      if (!n)
        return /* @__PURE__ */ u(ce, {});
      const ee = o.getFieldMeta(e), M = !_ && _t(Z, ee.touched, r);
      let O = ee.error;
      if (a) {
        const T = g(L, e);
        O = fn(ee.error, `profile.validationMsg.${T}.required`);
      }
      const te = () => Ts(e, F, P, b, c);
      return /* @__PURE__ */ u(
        Ws,
        {
          value: I,
          dropdownLabel: F,
          onClick: () => {
            gn(ot, te).then(({ fieldName: T, item: y }) => {
              Ns(T, y, !!c), qe.log("Guided input changed - onMouseUp", T, y), setTimeout(() => {
                var $, se;
                (se = ($ = document == null ? void 0 : document.getElementById) == null ? void 0 : $.call(document, "shipping-address-form-id")) == null || se.click(), qe.log("Guided input changed - Click Somewhere");
              }, 500);
            });
          },
          name: `${A}-${e}`,
          id: e,
          disabled: _ || !ut,
          required: a,
          disabledFilter: !0,
          className: w["guided-input"],
          "data-testid": `address-input-${e}-testid`,
          status: bt(M, O),
          message: Tt(C, M, O)
        }
      );
    }, Ls = (e, t, s) => e ? (t.push(s), t.length === 2 ? /* @__PURE__ */ u("div", { className: w["grouped-fields"], children: t.slice(t.length - 2, t.length) }) : /* @__PURE__ */ u(ce, {})) : s, ws = (e, t) => {
      var c;
      const s = m(f.VISIBLE_IF, e), { targetFieldName: n, targetFieldValue: a, valueNotInOptions: r } = s || {}, d = [];
      if (r) {
        const i = Se(n), { data: h } = i || {};
        d.push(...ae(h));
      }
      const l = ((c = o.values) == null ? void 0 : c[n]) ?? null;
      return !!(n && a && l !== a && (d.find((i) => (i == null ? void 0 : i.value) === l) && (t != null && t.contactId) || !(t != null && t.contactId) || !l));
    }, Os = (e, t) => e && !t || !e, ks = (e) => {
      const t = [], s = [], n = [];
      return e.forEach((a) => {
        const { fieldName: r, validations: d = {}, editable: l, isEditableOnce: c, ext: i, visible: h, options: V } = a, { required: b, max: _ = "", min: F = "" } = d, I = m(f.UI_HALF_WIDTH, i), L = m(f.DISPLAY_AS_INPUT, i), P = m(f.DEFAULT_COUNTRY_VALUE, i), ee = m(f.COUNTRY_NOT_EDITABLE, i), M = m(f.TYPE, i) === D.SHIPPING_DETAILS, O = m(f.HIDE_IF_CONFIRMATION, i), te = is.includes(r), Ee = un(a), v = m(f.CUSTOM_LABEL_KEY, i), R = h ? pn(C, r, A, M, v) : "", x = m(f.EXCLUDE_CHARS, i), k = m(f.STRING_LIMIT_BY_ENV, i), G = k && typeof k.max < "u" ? k.max : _, H = k && typeof k.min < "u" ? k.min : F;
        if (!ws(i, p) && (P && Le(Ht), Os(O, de))) {
          let y = /* @__PURE__ */ u(ce, {});
          switch (Ee) {
            case ue.TEXT: {
              y = /* @__PURE__ */ u("div", { children: Vs(r, {
                label: R,
                isEditableOnce: c,
                showCharCount: te,
                showAsInput: L,
                editable: l,
                required: b,
                max: G,
                min: H,
                excludeChars: x,
                ext: i
              }) }, r);
              break;
            }
            case ue.GUIDED_INPUT: {
              y = /* @__PURE__ */ u("div", { children: ys(
                r,
                {
                  label: R,
                  customLabel: v,
                  editable: l,
                  required: b,
                  isEditableOnce: c,
                  ext: i,
                  options: V
                }
              ) }, r);
              break;
            }
            case ue.PHONE: {
              y = /* @__PURE__ */ u("div", { children: Fs(r, U, W, {
                label: R,
                customLabel: v,
                showAsInput: L,
                editable: l,
                required: b,
                disabledCountry: ee
              }) }, r);
              break;
            }
            case ue.CHECKBOX: {
              y = /* @__PURE__ */ u("div", { children: _s(r, {
                label: R,
                isEditableOnce: c,
                showCharCount: te,
                showAsInput: L,
                editable: l,
                required: b,
                max: _,
                min: F,
                excludeChars: x,
                ext: i
              }) }, r);
              break;
            }
          }
          y = Ls(I, n, y), M ? s.push(y) : t.push(y);
        }
      }), { renderAddressInputs: t, renderShippingInputs: s };
    }, De = (e) => {
      const { name: t } = e.target, [, ...s] = String(t).split("-"), n = g(s.join("-"), t);
      o.setFieldTouched(n);
    }, vs = (e) => {
      const { name: t, value: s } = e.target, [, ...n] = String(t).split("-"), a = g(n.join("-"), t);
      o.setFieldValue(a, s, !0);
    }, Rs = (e) => {
      const { name: t } = e.currentTarget, [, ...s] = String(t).split("-"), n = g(s.join("-"), t);
      o.setFieldTouched(n, !0, !0);
    }, Ns = async (e, t, s = !1) => {
      var l;
      const { value: n, name: a } = t;
      let r = a;
      (e === D.STATE || s) && (r = n), await o.setFieldValue(e, r), await In(S, e, o), Qe(!0);
      const d = g(
        (l = N == null ? void 0 : N.find((c) => c.primaryField === e)) == null ? void 0 : l.secondaryField
      );
      d && o.setFieldValue(d, "");
    }, { renderAddressInputs: zs, renderShippingInputs: gt } = $s(
      () => ks(S),
      [
        S,
        o.values,
        o.touched,
        o.errors,
        U,
        W,
        J,
        Y,
        Ue,
        _e,
        Ye,
        ct,
        de,
        Ke,
        je
      ]
    );
    return /* @__PURE__ */ ne(
      "div",
      {
        className: `${de ? w["address-input-drawer"] : w["address-input-container"]} ${Ot} `,
        "data-testid": "address-input-container-testid",
        "data-pod-name": "profile",
        id: "address-input-container-id",
        children: [
          Ge && /* @__PURE__ */ u("div", { className: w["address-custom-header"], children: Ge }),
          /* @__PURE__ */ u("div", { className: w["address-type-title"], "data-testid": "address-title-testid", "data-pod-name": "profile", children: He ?? `${Bt}` }),
          Q && !he && /* @__PURE__ */ ne("div", { children: [
            /* @__PURE__ */ u(
              En,
              {
                callback: ls,
                allowEnterManually: kt,
                contactType: A,
                status: be,
                title: He
              }
            ),
            pe && be === Ae.INVALID && /* @__PURE__ */ u(Sn, { t: C, touched: !0, error: pe }),
            pe && be !== Ae.INVALID && pe
          ] }),
          (!Q || he) && /* @__PURE__ */ u("div", { className: w["address-form"], children: /* @__PURE__ */ ne(
            "form",
            {
              id: "shipping-address-form-id",
              "data-testid": "shipping-address-form-testid",
              "data-pod-name": "profile",
              onSubmitCapture: (e) => Es(!0, e),
              onSubmit: o.handleSubmit,
              children: [
                /* @__PURE__ */ u("div", { className: `${w["general-address-container"]} ${pt} ${ve}`, children: zs }),
                Rt && gt.length > 0 && /* @__PURE__ */ u("div", { className: `${w["shipping-detail-container"]} ${pt} ${ve}`, children: /* @__PURE__ */ ne("div", { children: [
                  gt,
                  ct && /* @__PURE__ */ u(
                    Et,
                    {
                      "data-testid": "default-checkbox-testid",
                      "data-pod-name": "profile",
                      name: `${A}-isDefault`,
                      id: `${A}-isDefault`,
                      text: C("profile.AddressInput.defaultAddressCheckboxLabel"),
                      className: "default-address-checkbox",
                      checked: (St = o.values) == null ? void 0 : St.isDefault,
                      disabled: ss,
                      onChange: () => {
                        var e;
                        o.setFieldValue("isDefault", !((e = o.values) != null && e.isDefault));
                      }
                    }
                  ),
                  !de && !ie && /* @__PURE__ */ u("div", { className: w["shipping-address-form-btn"], children: /* @__PURE__ */ u(
                    en,
                    {
                      title: C("profile.AddressInput.confirmButton"),
                      type: Hs.SUBMIT,
                      "data-testid": "confirm-button-testid",
                      "data-pod-name": "profile",
                      buttonStyle: Ys.SOLID,
                      size: Ks.MEDIUM,
                      disabled: !X,
                      isLoading: Ke
                    }
                  ) }),
                  A === oe.Shipping && de && !ie && /* @__PURE__ */ u("div", { className: w["hidden-button"], children: /* @__PURE__ */ u(
                    js,
                    {
                      onClick: () => Ds(),
                      ref: lt,
                      "data-testid": "hidden-button",
                      "data-pod-name": "profile",
                      children: " "
                    }
                  ) })
                ] }) })
              ]
            }
          ) }),
          Wt && /* @__PURE__ */ u(
            Dn,
            {
              ...Qt,
              callback: window.handleSearchDrawerSelect,
              onClose: ms,
              isLoading: Xt,
              title: Jt
            }
          )
        ]
      }
    );
  }
);
ro.displayName = "AddressInput";
export {
  ro as A,
  bn as o
};
//# sourceMappingURL=AddressInput-0f8a7cd4.mjs.map
